// utils/permissions.js
export const PermissionEnum = {
  ShowAllConsultRequests: 'ShowAllConsultRequests',
  ViewClosedConsultRequests: 'ViewClosedConsultRequests',
  ViewAndEditSettings: 'ViewAndEditSettings',
  ShowFullPatientNames: 'ShowFullPatientNames',
  ViewAdminConsultTable: 'ViewAdminConsultTable',
  CreateSharedMacros: 'CreateSharedMacros',
  HasPaocPermission: 'HasPaocPermission',
};

export const hasPermission = (permissions, perm) =>
  Array.isArray(permissions) && permissions.includes(perm);
